var styles = {
    "collapsible-wrapper": "collapsible-module_collapsible-wrapper__RwJye",
    "cta-wrapper": "collapsible-module_cta-wrapper__muaWZ"
};

export { styles as default };
